var _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIluminacion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1929",
    "data-name": "Grupo 1929",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.879,
    height: 95.028,
    viewBox: "0 0 95.879 95.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_190",
    "data-name": "Elipse 190",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(32.596 32.888)",
    fill: "#003082"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lampara_1_",
    "data-name": "lampara (1)",
    transform: "translate(61.159 60.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1928",
    "data-name": "Grupo 1928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M33.835,6.647,28.08.893a3.054,3.054,0,0,0-4.96.947,3.049,3.049,0,0,0-4.559,2.48A3.051,3.051,0,0,0,15.682,7.2a3.048,3.048,0,0,0-2.877,2.876,3.053,3.053,0,0,0-2.585,4.363L8.536,16.121a3.052,3.052,0,0,0-3.474.6L1.5,20.284a5.094,5.094,0,0,0-.6,6.474,5.085,5.085,0,0,0,7.069,7.071,5.084,5.084,0,0,0,6.475-.6l3.567-3.567a3.052,3.052,0,0,0,.6-3.474l1.683-1.684a3.05,3.05,0,0,0,4.362-2.587,3.048,3.048,0,0,0,2.879-2.877,3.044,3.044,0,0,0,2.876-2.877,3.05,3.05,0,0,0,2.481-4.561,3.05,3.05,0,0,0,.947-4.958ZM2.934,31.793a3.057,3.057,0,0,1-.6-3.473l4.069,4.069A3.057,3.057,0,0,1,2.934,31.793Zm13.637-3.567L13,31.793a3.05,3.05,0,0,1-4.316,0h0L2.934,26.039a3.055,3.055,0,0,1,0-4.316L6.5,18.156a1.017,1.017,0,0,1,1.439,0l8.632,8.632A1.017,1.017,0,0,1,16.571,28.227Zm-3.6-7.913,1.439-1.439,1.439,1.439-1.439,1.439ZM17.29,24.63l-1.439-1.439,1.439-1.439,1.439,1.439Zm5.035-2.158a1.017,1.017,0,0,1-1.439,0l-5.755-5.755a1.018,1.018,0,0,0-1.439,0l-2.158,2.158L10.1,17.437l2.158-2.158a1.018,1.018,0,0,0,0-1.439A1.017,1.017,0,0,1,13.694,12.4l8.632,8.632h0A1.019,1.019,0,0,1,22.326,22.472ZM25.2,19.595a1.018,1.018,0,0,1-1.439,0l-8.632-8.632a1.017,1.017,0,0,1,1.439-1.439L25.2,18.156A1.018,1.018,0,0,1,25.2,19.595Zm2.877-2.877a1.018,1.018,0,0,1-1.439,0L18.01,8.086a1.017,1.017,0,1,1,1.439-1.439l8.632,8.632A1.018,1.018,0,0,1,28.08,16.718Zm2.877-2.877a1.018,1.018,0,0,1-1.439,0L20.887,5.209A1.017,1.017,0,1,1,22.326,3.77l1.438,1.438h0L30.958,12.4A1.017,1.017,0,0,1,30.958,13.84ZM32.4,9.524a1.019,1.019,0,0,1-1.439,0L25.2,3.77a1.017,1.017,0,0,1,1.439-1.439L32.4,8.086A1.017,1.017,0,0,1,32.4,9.524Z",
    transform: "translate(-0.009 0)",
    fill: "#003082"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_071-fan-1",
    "data-name": "071-fan-1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_190",
    "data-name": "Grupo 190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_189",
    "data-name": "Grupo 189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M118.8,33.822A38.536,38.536,0,1,0,75.834,76.787v7.377H64.824a4.719,4.719,0,0,0-4.719,4.719V93.6H101V88.882a4.719,4.719,0,0,0-4.719-4.719H85.272V76.787A38.537,38.537,0,0,0,118.8,33.822ZM96.282,87.31a1.573,1.573,0,0,1,1.573,1.573v1.573h-34.6V88.882a1.573,1.573,0,0,1,1.573-1.573Zm-17.3-3.146V77.872h3.146v6.292ZM80.553,73.94a35.391,35.391,0,1,1,35.391-35.391A35.391,35.391,0,0,1,80.553,73.94Z",
    transform: "translate(-42.013 0)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M136.1,64.242V61.1a1.573,1.573,0,0,0-1.573-1.573H116.132a17.29,17.29,0,0,0-9.922-31.458h-3.146a1.573,1.573,0,0,0-1.573,1.573V48.028A17.29,17.29,0,0,0,70.033,57.95V61.1a1.573,1.573,0,0,0,1.573,1.573H90a17.29,17.29,0,0,0,9.922,31.458h3.146a1.573,1.573,0,0,0,1.573-1.573V74.164A17.29,17.29,0,0,0,136.1,64.242ZM104.637,31.211h1.573a14.156,14.156,0,0,1,4.348,27.622,7.865,7.865,0,0,0-5.92-5.444ZM73.179,59.523V57.95A14.156,14.156,0,0,1,100.8,53.6a7.865,7.865,0,0,0-5.442,5.919Zm28.313,31.458H99.918A14.156,14.156,0,0,1,95.571,63.36a7.865,7.865,0,0,0,5.92,5.444V90.982Zm1.573-25.167a4.719,4.719,0,1,1,4.719-4.719A4.719,4.719,0,0,1,103.064,65.815Zm15.7,12.557a14.156,14.156,0,0,1-13.438-9.784,7.865,7.865,0,0,0,5.442-5.919H132.95v1.573A14.156,14.156,0,0,1,118.767,78.372Z",
    transform: "translate(-64.524 -22.547)",
    fill: "#86888b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIluminacion);
export default __webpack_public_path__ + "static/media/iluminacion.6b6b4725c17665b76f644d30d2b6cd21.svg";
export { ForwardRef as ReactComponent };